<template>
    <NxSelect
    :value="localValue"
    :options="listOptions"
    labelText="Canal:"
    id="selectCanal"
    placeholder="Selecione o Canal"
    @update:value="handleValueUpdate"
  ></NxSelect>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxSelectCampanhaCanal',
  mixins: [ useReactiveModelMixin('value') ],
  data () {
    return {
      listOptions: [ {value: 1, text: 'EMAIL'},
        {value: 2, text: 'SMS'},
        {value: 3, text: 'WHATSAPP'}],
      selected: null
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectCampanhaCanal.vue